/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { Pageable } from '../model/models';
import { PagedModelTipoPraticaAttributoValoreDTO } from '../model/models';
import { TipoPraticaAttributoValoreCreationForm } from '../model/models';
import { TipoPraticaAttributoValoreDTO } from '../model/models';
import { TipoPraticaAttributoValorePatchForm } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface CreateTipoPraticaAttributoValoreRequestParams {
    idTipoPratica: string;
    idAttr: string;
    tipoPraticaAttributoValoreCreationForm: TipoPraticaAttributoValoreCreationForm;
}

export interface DeleteTipoPraticaAttributoValoreRequestParams {
    idTipoPratica: string;
    idAttr: string;
    idVal: string;
}

export interface GetTipoPraticaAttributoValoreRequestParams {
    idTipoPratica: string;
    idAttr: string;
    idVal: string;
}

export interface ListTipoPraticaAttributoValoriRequestParams {
    idTipoPratica: string;
    idAttr: string;
    pageable: Pageable;
}

export interface UpdateTipoPraticaAttributoValoreRequestParams {
    idTipoPratica: string;
    idAttr: string;
    idVal: string;
    tipoPraticaAttributoValorePatchForm: TipoPraticaAttributoValorePatchForm;
}


export interface TipoPraticaAttributoValoriControllerServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Crea una nuova opzione catalogata dell\&#39;attributo (CUSTOM_SINGLE_CHOICE / CUSTOM_MULTIPLE_CHOICE)
     * 
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/attributi/{idAttr}/valori
* @param requestParameters
     */
    createTipoPraticaAttributoValore(requestParameters: CreateTipoPraticaAttributoValoreRequestParams, extraHttpRequestParams?: any): Observable<TipoPraticaAttributoValoreDTO>;

    /**
     * Elimina una opzione dell\&#39;attributo
     * 
     * @endpoint delete /api/v1/gestione/tipi-pratica/{idTipoPratica}/attributi/{idAttr}/valori/{idVal}
* @param requestParameters
     */
    deleteTipoPraticaAttributoValore(requestParameters: DeleteTipoPraticaAttributoValoreRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Dettaglio di una opzione per id (path consistency: 404 se la chain e\&#39; rotta)
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/attributi/{idAttr}/valori/{idVal}
* @param requestParameters
     */
    getTipoPraticaAttributoValore(requestParameters: GetTipoPraticaAttributoValoreRequestParams, extraHttpRequestParams?: any): Observable<TipoPraticaAttributoValoreDTO>;

    /**
     * Lista paginata delle opzioni dell\&#39;attributo (sort default: ordine, id ASC)
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/attributi/{idAttr}/valori
* @param requestParameters
     */
    listTipoPraticaAttributoValori(requestParameters: ListTipoPraticaAttributoValoriRequestParams, extraHttpRequestParams?: any): Observable<PagedModelTipoPraticaAttributoValoreDTO>;

    /**
     * Replace di una opzione (richiede version per optimistic lock; value frozen post-pubblicazione)
     * 
     * @endpoint put /api/v1/gestione/tipi-pratica/{idTipoPratica}/attributi/{idAttr}/valori/{idVal}
* @param requestParameters
     */
    updateTipoPraticaAttributoValore(requestParameters: UpdateTipoPraticaAttributoValoreRequestParams, extraHttpRequestParams?: any): Observable<TipoPraticaAttributoValoreDTO>;

}
